// extracted by mini-css-extract-plugin
export var searchPage = "search-module--searchPage--Def1k";
export var searchContainer = "search-module--searchContainer--mOeFN";
export var activeContainer = "search-module--activeContainer--Pg2CV";
export var backAndForthRight = "search-module--backAndForthRight--P0Xuu";
export var wobbleRightAndLeft = "search-module--wobbleRightAndLeft--8aqCg";
export var animateBg = "search-module--animateBg--89Mc2";